let calledHextom = false;

const updateRemoveButtonPids = () => {
  // console.log("updateRemoveButtonPids running");
  document.querySelectorAll('[data-cart-remove]').forEach((el) => {
    //const $el = $(el);
    const productId = Number(el.getAttribute('data-product-id'));
    let pid = '';
    // console.log("updateRemoveButtonPids loop");
    for (let ind = 0; ind < window.cart.items.length; ind++) {
      const item = window.cart.items[ind];

      if (item && item.product_id && item.product_id === productId) {
        if (item.properties && item.properties.pid) {
          pid = item.properties.pid;
        }
      }
    }

    el.setAttribute('data-pid', pid);
  });
};

const tryCallFSB = () => {
  if (calledHextom) {
    return;
  }

  if (window.hextom_fsb && typeof window.hextom_fsb.call === 'function') {
    window.hextom_fsb.call();
    calledHextom = true;
  } else {
    setTimeout(() => {
      tryCallFSB();
    }, 1000);
  }
};

export default () => {
  /*
  function getAllSiblings(elem, filter) {
    var sibs = [];
    elem = elem.parentNode.firstChild;
    while ((elem = elem.nextSibling)) {
      if (matches(elem, filter)) {
        sibs.push(elem);
      }
    }
    return sibs;
  }
  */
  document.addEventListener('cartDidUpdate', () => {
    //document.addEventListener('cartDidUpdate', () => {
    // console.log("cartDidUpdate running first");
    updateRemoveButtonPids();
    // console.log("cartDidUpdate running");
    document.querySelectorAll('[data-quantity-plus]').forEach((el) => {
      //const $el = $(el);
      // console.log(el.getAttribute('data-current-quantity'));
      if (el.getAttribute('data-current-quantity') >= 10) {
        // console.log("+10");
        el.classList.add('disabled');
      } else {
        el.classList.remove('disabled');
      }
      if (el.getAttribute('data-current-quantity') > 10) {
        //$el.siblings('[data-quantity-input]').val(10).trigger('change');
        if (!el.querySelector('[data-quantity-input]')) {
          return;
        }

        el.querySelector('[data-quantity-input]').onchange = function () {
          change_inp();
        };

        /* eslint-disable-next-line no-inner-declarations */
        function change_inp() {
          let get_inp = el.querySelector('[data-quantity-input]');
          get_inp.value = '10';
          get_inp.dispatchEvent(new Event('change'));
        }
        change_inp();
        // console.log('check value:'+el.querySelector('[data-quantity-input]').getAttribute('value'));
        //var siblings_vari = Array.from(el.parentElement.children).filter(x => x != el && x.matches('[data-quantity-input]'));
        //console.log('chang'+siblings_vari.getAttribute('value'));
        //siblings_vari.setAttribute('value',10);
      }
    });
  });

  document.addEventListener('cartDidOpen', () => {
    //document.addEventListener('cartDidOpen', () => {
    updateRemoveButtonPids();
    tryCallFSB();
  });

  // Optimizely Test
  if (window.location.href.indexOf('cart') > -1) {
    updateRemoveButtonPids();
    tryCallFSB();
  }

  // $(document).on('click', '[data-submit-parent-form]', (e) => {
  //   const $el = $(e.currentTarget);
  //   const $parentForm = $el.closest('form');

  //   console.log('!!! parent form:', $parentForm);

  //   $parentForm.submit();

  //   // setTimeout(() => {
  //   //   if (parentForm) {
  //   //     parentForm.submit();
  //   //   }
  //   // }, 100);
  // });
};
